import img1 from "assets/images/siteRODRIGOMENDES.PNG";
import img2 from "assets/images/siteMatematicaAcessivel.PNG";
import img3 from "assets/images/siteMATEMATICAPARATODOS.PNG";

export default [
  {
    image: img1,
    name: "Instituto Rodrigo Mendes",
    route: "https://institutorodrigomendes.org.br/",
  },
  {
    image: img2,
    name: "Matemática Acessível",
    route: "https://www.matematicaacessivel.com.br/",
  },
  {
    image: img3,
    name: "Matematica para todos",
    route: "https://matematicaparatodos.com.br/",
  },
];
